if (!customElements.get('klaviyo-form')) {
	class KlaviyoSubscribe extends HTMLElement {
		constructor() {
			super();
			this.list_id = this.dataset.listId;
			this.campaign_id = this.dataset.campaignId;
			this.dataset.klaviyo !== 'false' ? this.hasKlaviyo = true : this.hasKlaviyo = false;
			this.form = this.querySelector('form');
			this.input = this.form.querySelector('input[type="email"]');
			this.nameInput = this.form.querySelector('input[type="text"]');
			this.submit = this.form.querySelector('[type="submit"]');
			this.errorWrapper = this.form.querySelector('.email__error');
			this.error = this.form.querySelector('.error__text');
			this.success = this.form.querySelector('.email__input-success');
			this.wrapper = this.form.querySelector('.newsletter-form__wrapper');
			this.companyId = 'TLBfBq';

			if (this.hasKlaviyo) {
				this.form.addEventListener('submit', this.klaviyoFormSubmit.bind(this));
			}

			this.input.addEventListener('input', () => this.hideError());
		}

		formData() {
			const email = this.input ? this.input.value : '';
			const name = this.nameInput && this.nameInput.value ? this.nameInput.value : null;

			const profileAttributes = {
				email: email,
			};

			if (name) {
				profileAttributes.first_name = name;
			}

			return {
				method: 'POST',
				headers: { revision: '2024-02-15', 'content-type': 'application/json' },
				body: JSON.stringify({
					data: {
						type: 'subscription',
						attributes: {
							custom_source: 'Klaviyo form',
							profile: {
								data: {
									type: 'profile',
									attributes: profileAttributes,
								}
							}
						},
						relationships: { list: { data: { type: 'list', id: this.list_id } } }
					}
				})
			};
		}

		klaviyoFormSubmit(evt) {
			evt.preventDefault()
			if (this.list_id === '') {
				this.showError('This customer is already subscribed!');
			}

			console.log(this.inputValidation())
			if (!this.inputValidation()) return;

			const _this = this;

			fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.companyId}`, this.formData())
				.then(response => {
					(response.status === 202) ? _this.showSuccess() : _this.showError()
				})
				.catch(err => {
					console.error(err);
					_this.showError()
				});
		}

		showSuccess() {
			if (this.success) {
				this.success.setAttribute('aria-hidden', 'false');
				this.input.classList.add('disabled');
				this.input.blur();
				this.wrapper.classList.add('success');
				this.submit.setAttribute('disabled', 'true');
			}
		}

		hideError() {
			this.errorWrapper.setAttribute('aria-hidden', 'true');
			this.wrapper.classList.remove('error');
			this.submit.removeAttribute('disabled');
		}

		showError(errorText) {
			this.errorWrapper.setAttribute('aria-hidden', 'false');
			// check line below (was errorText = errorText ?? this.error.textContent;)
			errorText = errorText || this.error.textContent;
			this.error.textContent = errorText;
			this.wrapper.classList.remove('success');
			this.wrapper.classList.add('error');
			this.submit.setAttribute('disabled', 'true');
		}

		inputValidation() {
			const emailVal = this.input ? this.input.value : '';

			if (!emailVal) return false;

			const emailRe = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			const isEmailValid = emailRe.test(emailVal);

			if (isEmailValid) {
				this.hideError();
				return true;
			} else {
				this.showError();
				return false;
			}
		}
	}

	customElements.define('klaviyo-form', KlaviyoSubscribe);
}